// src/lib/session.js
const KEY = 'auth.session'; // JSON payload: { userId, refreshToken, ts }
const REDIRECT_KEY = 'redirectAfterLogin';
const LEGACY_TOKEN_KEY = 'authToken'; // some parts of the app still read this

// ---------- Redirect helpers ----------
export function setRedirectAfterLogin(path) {
  localStorage.setItem(REDIRECT_KEY, path);
}
export function consumeRedirectAfterLogin() {
  const v = localStorage.getItem(REDIRECT_KEY);
  if (v) localStorage.removeItem(REDIRECT_KEY);
  return v || null;
}

// ---------- Auth/session helpers ----------
/**
 * Persist session after successful login.
 * Also writes legacy 'authToken' for older code paths.
 */
export function login({ userId, refreshToken }) {
  const data = { userId, refreshToken, ts: Date.now() };
  localStorage.setItem(KEY, JSON.stringify(data));
  if (refreshToken) {
    localStorage.setItem(LEGACY_TOKEN_KEY, refreshToken); // backward compatibility
  }
  return data;
}

export function logout() {
  localStorage.removeItem(KEY);
  localStorage.removeItem(REDIRECT_KEY);
  localStorage.removeItem(LEGACY_TOKEN_KEY);
  // wipe any onboarding caches if you use them
  localStorage.removeItem('onboarding.brand');
  localStorage.removeItem('onboarding.topic');
}

/** Safely parse the stored session object */
export function getSession() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || 'null');
  } catch {
    return null;
  }
}

/** Returns true if we have a usable token */
export function isLoggedIn() {
  return !!getToken();
}

/**
 * New code should call this to get the bearer token.
 * Falls back to legacy 'authToken' to avoid breaking older code.
 */
export function getToken() {
  const session = getSession();
  const tokenFromSession = session?.refreshToken || '';
  const tokenFromLegacy = localStorage.getItem(LEGACY_TOKEN_KEY) || '';
  return tokenFromSession || tokenFromLegacy || '';
}

/** Optional helpers that can be handy elsewhere */
export function getUserId() {
  return getSession()?.userId || null;
}
export function setToken(token) {
  const current = getSession() || { userId: null, ts: Date.now() };
  const next = { ...current, refreshToken: token, ts: Date.now() };
  localStorage.setItem(KEY, JSON.stringify(next));
  if (token) localStorage.setItem(LEGACY_TOKEN_KEY, token);
  else localStorage.removeItem(LEGACY_TOKEN_KEY);
  return next;
}
